"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentLineItem = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const shipment_entity_1 = require("./shipment.entity");
const order_line_item_entity_1 = require("./order-line-item.entity");
let ShipmentLineItem = class ShipmentLineItem {
};
exports.ShipmentLineItem = ShipmentLineItem;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], ShipmentLineItem.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => shipment_entity_1.Shipment, (shipment) => shipment.shipmentLineItems, { onDelete: 'CASCADE', nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'shipmentId' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof shipment_entity_1.Shipment !== "undefined" && shipment_entity_1.Shipment) === "function" ? _a : Object)
], ShipmentLineItem.prototype, "shipment", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'shipmentId' }),
    tslib_1.__metadata("design:type", Number)
], ShipmentLineItem.prototype, "shipmentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => order_line_item_entity_1.OrderLineItem, (lineItem) => lineItem.shipmentItems, { onDelete: 'CASCADE', nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'lineItemId' }),
    tslib_1.__metadata("design:type", typeof (_b = typeof order_line_item_entity_1.OrderLineItem !== "undefined" && order_line_item_entity_1.OrderLineItem) === "function" ? _b : Object)
], ShipmentLineItem.prototype, "lineItem", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'lineItemId' }),
    tslib_1.__metadata("design:type", Number)
], ShipmentLineItem.prototype, "lineItemId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    tslib_1.__metadata("design:type", Number)
], ShipmentLineItem.prototype, "quantity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], ShipmentLineItem.prototype, "createdAt", void 0);
exports.ShipmentLineItem = ShipmentLineItem = tslib_1.__decorate([
    (0, typeorm_1.Entity)('shipment_line_items'),
    (0, typeorm_1.Unique)(['lineItemId'])
], ShipmentLineItem);
